import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import Checkbox from "../../components/CheckBox";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";
import getFirstDateOfMonth from "../../utils/getFirstDateOfMonth";
import getLastDateOfMonth from "../../utils/getLastDateOfMonth";
import useAuth from "../../hooks/useAuth";
import ShopApi from "../../apis/shop.api";

const DeleteAccountDetails = () => {
  const [checked, setChecked] = useState(false);
  const { ceoInfo } = useAuth();
  const navigate = useNavigate()
  const [premiumAmountWithVat, setPremiumAmountWithVat] = useState(0);
  
  const getPremiumAmountWithVat = async () => {
    if (ceoInfo?.shop_idx) {
      const res = await ShopApi.getPremiumAmountWithVat({ shopIdx: ceoInfo?.shop_idx, currentDate: new Date() });
      if (res.data.data) {
        setPremiumAmountWithVat(res.data.data);
      }
    }
  };
  useEffect(() => {
    getPremiumAmountWithVat();
  }, []);
  return (
    <div>
      <TopPageBack>
        <b>서비스 탈퇴</b>
      </TopPageBack>
      <div className="h-4"></div>
      <div className="mx-5">
        <div className="text-22 text-darkblue font-bold">
          <div>아래의 정보와</div>
          <div>탈퇴 시 유의사항을 확인해 주세요.</div>
        </div>

        <div className="review-card2 py-4 mt-6 flex flex-col">
          <div className="flex flex-col gap-2">
            <div className="text-lg font-bold mb-1">최근 납부 정보</div>
            <div className="bg-light-aqua2 p-4 rounded-lg ">
              <div className="mb-8">
                <div className="text-15 text-darkblue mb-2">납부 금액</div>
                <div className="text-base font-bold text-darkblue">
                  {premiumAmountWithVat.toLocaleString().replaceAll('.',',')}원<span className="font-normal">(부가세 포함)</span>
                </div>
              </div>
              <div>
                <div className="text-base text-darkblue mb-2">
                  이용 가능 기간
                </div>
                <div className="text-base font-bold text-darkblue">
                  {getFirstDateOfMonth() + " ~ " + getLastDateOfMonth()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-6 flex items-center gap-1">
          <Checkbox checked={checked} onChange={() => setChecked(!checked)} />{" "}
          <span onClick={() => setChecked(!checked)} className="text-darkblue text-15 font-bold ">
            유의사항 확인
          </span>
        </div>

        <div className="text-darkblue mt-3">
          탈퇴 시 이용약관 및 개인정보처리방침에서 정한 보관항목을 제외한 모든
          정보가 삭제되며 절대 복구할 수 없음을 이해하고 동의합니다.
        </div>

        <div className="px-5 absolute w-full bottom-2 left-0">
          <SolidBlueBtn
            disabled={!checked}
            className="w-full mt-5"
            onClick={()=> navigate(ROUTE_PATHS.Representative)}
          >
            다음
          </SolidBlueBtn>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountDetails;
